import styled from 'styled-components';

export const Div = styled.div`
    height: 500px;
    width: 600px;
`;